<h3>Icons by product group</h3>
<p>Download the PNG and ICO files in ZIP form by clicking the product below.</p>
<uilab-mat-card>
  <ul class="products">
    @for (product of products; track product) {
      <li
        class="item"
        (click)="download(product)"
        >
        <uilab-icon icon="action--download"></uilab-icon>
        <a class="product">{{ product }}</a>
      </li>
    }
  </ul>
</uilab-mat-card>
